/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const exhibitorRef = con.eventDB.collection(cn).doc('ExhibitorList').collection('Exhibitors');
const categoryRef = con.eventDB.collection(cn).doc("ExhibitorCategories").collection("Category");
const storageRef = con.storageRef;
var Session_TimeZone = ls.getSessionValueByKey('Session_Event_TZ');
var FetchExhibitorVisitoReportAPI = con.FetchExhibitorVisitoReportAPI;
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var resourceCategoryRef = con.eventDB.collection(cn).doc("Resources").collection("Categories");
var resourcesRef = con.eventDB.collection(cn).doc("Resources").collection("resourceList");
var ResourceDeleteAPI = con.ResourceDeleteAPI;

export default {
    addResourceCategory(context, field) {
        debugger;
        let AutoID =  new Date().getTime().toString();
        return new Promise((resolve, reject) => {
            resourceCategoryRef.doc(`${AutoID}`).set({
                Id: AutoID,
                Name: field.Name,
                IsHidden : field.IsHidden,
                CreatedTime: new Date(),
            }).then(function() {
                resolve({ status: 200, message: "Category Created" })
            }).catch(function(error) {
                    reject(error)
                })
        })
    },
    fetchCategory({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            resourceCategoryRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    uploadFiles(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function(snapshot) {
                    snapshot.ref.getDownloadURL().then(function(url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve(null)
            }
        })
    },
    addResources(context, field) {
        debugger;
        let AutoID =  new Date().getTime().toString();
        var isPinned = false;
        if(field.resourceType == 'code'){
            isPinned = true;
        }
        return new Promise((resolve, reject) => {
            resourcesRef.doc(`${AutoID}`).set({
                Id: AutoID,
                ResourceName: field.resourceName,
                Description: field.description,
                SelectedCategory: field.selectedCategory,
                ResourceType: field.resourceType,
                CoverImageURL: field.coverImageURL,
                ResourcePath: field.uploadedResourcePath,
                EmbedCode: field.embedCode != null ? field.embedCode : '',
                IsPublished: true,
                IsPinned: isPinned,
                FileName: field.fileName != undefined ? field.fileName : '',
                HyperLinkUrl: field.hyperLinkUrl != undefined ? field.hyperLinkUrl : null,
                CreatedTime: new Date(),
            }).then(function() {
                resolve({ status: 200, message: "Resource Added" })
            }).catch(function(error) {
                    reject(error)
                })
        })
    },
    fetchAllResources({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            resourcesRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_RESOURCES', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    updateStatus(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            resourcesRef.doc(`${field.id}`).update({
                    IsPublished: field.IsPublished,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    }, 
    removeResourceFromEdit(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            resourcesRef.doc(`${field.id}`).update({
                    ResourcePath: "",
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'File Removed.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },
    updateResources(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            resourcesRef.doc(`${field.id}`).update({
                ResourceName: field.resourceName,
                Description: field.description,
                SelectedCategory: field.selectedCategory,
                CoverImageURL: field.coverImageURL,
                ResourcePath: field.uploadedResourcePath,
                EmbedCode: field.embedCode != null ? field.embedCode : '',
                FileName: field.fileName != undefined ? field.fileName : '',
                HyperLinkUrl: field.hyperLinkUrl != undefined ? field.hyperLinkUrl : null,
                LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    context.dispatch('fetchAllResources');
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    }, 
    updatePinnedStatus(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            resourcesRef.doc(`${field.id}`).update({
                    IsPinned: field.IsPinned,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    }, 
    updateCategoryStatus(context, field) {
        debugger;
        console.log("field======",field);
        return new Promise((resolve, reject) => {
            resourceCategoryRef.doc(`${field.id}`).update({
                    IsHidden: field.IsHidden,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    }, 
    getFirebaseAccessToken(context){
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
      })
    },
    removeRecords(context, data) {
        console.log("ResourceId==========",data);
        return new Promise((resolve, reject) => {
                context.dispatch('getFirebaseAccessToken').then(accessToken => {
                    let headers = {
                        'Authorization': `Bearer ${accessToken}`,
                        "content-type": 'application/json'
                    }

                    let requestData = {
                        "key": {
                            "instanceId": "OA_UAT",
                            "clientId": Session_Client_Id,
                            "eventId": Session_Event_Id
                        },
                        "data": {
                            "resourceId": data.data                                         
                        }
                    }
                    axios.delete( ResourceDeleteAPI,{ headers:headers,data: requestData}).then((response) => {
                        resolve({status:200, message: "Resource Deleted"})
                    }).catch((error) => { 
                        console.log(error) 
                        resolve({status:500, message: "Resource Not Deleted"})
                    })
                })
        })
    },

}
